export const GOOGLE_KEY =
  process.env.NEXT_PUBLIC_GOOGLE_KEY ||
  'AIzaSyDqifcFwTM-vhaiPRnPIphF0W2V5xnKqKE';
